import { Fragment, useCallback, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FilterButton } from "../../../components/__simple/_filterButton";
import { useParams } from "react-router";
import axios from "axios";
import { slugSplitter } from "../../../utils/slugManager";
import config from "../../../configuration/config";
import ImageGallery from "react-image-gallery";
import Skeleton from "react-loading-skeleton";
import { EmptyState } from "../../../components/EmptyState";

export function VehicleGalleryPage() {
    const { t: trans, i18n } = useTranslation(["car", "new", "vehicales"]);
    const { slug, brand, group, year } = useParams();
    const [gallery, setGallery] = useState([]);
    const [types, setTypes] = useState([]);
    const [filteredGallery, setFilteredGallery] = useState([]);
    const [filter, setFilter] = useState();
    const [innerCarImages, setInnerCarImages] = useState([]);
    const [outerCarImages, setOuterCarImages] = useState([]);
    const [wheels, setWheels] = useState([]);
    const [activePart, setActivePart] = useState(0);
    const popRef = useRef(null);
    const [activeImage, setActiveImage] = useState(0);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    let lang = (i18n.language || 'ar');

    useEffect(() => {
        setFilteredGallery([]);
        setInnerCarImages([]);
        setOuterCarImages([]);
        setWheels([]);

        callback();
    }, [group, year]);

    const callback = useCallback(async () => {
        setIsLoading(true);
        try {
            const innerImages = [];
            const outerImages = [];
            const wheelsImages = [];
            const response = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/VehicleGallery/" + slugSplitter(brand) + "/" + group + "/" + year + "/gallery",
                method: "get",
            });

            setTypes(response.data.types);
            setGallery(response.data.gallery || []);

            if (Array.isArray(response?.data?.gallery)) {
                response.data.gallery.forEach((item) => {
                    item["original"] = config.mainURL + item.imagePath;
                    item["thumbnail"] = config.mainURL + item.imagePath;
                    item["originalHeight"] = "50";
                    item["originalWidth"] = "50";
                    item["sizes"] = "50";
                    item["fullscreen"] = config.mainURL + item.imagePath;
                    if (item?.type?.toLowerCase().includes("inner")) {
                        innerImages.push(item);
                    } else if (item?.type?.toLowerCase().includes("wheel")) {
                        wheelsImages.push(item);
                    } else {
                        outerImages.push(item);
                    }
                });

                setInnerCarImages(innerImages);
                setOuterCarImages(outerImages);
                setWheels(wheelsImages);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }, [group, year, brand, lang]);


    useEffect(() => {
        const ap = outerCarImages.length > 0 ? 0 : (innerCarImages.length > 0 ? 1 : 2)
        if (wheels.length > 0 || outerCarImages.length > 0 || innerCarImages.length > 0) {
            filterImage(ap);
            setActivePart(ap);
        }
    }, [wheels, outerCarImages, innerCarImages])

    function filterImage(filterIndex) {
        if (filterIndex === 0) {
            setFilteredGallery(outerCarImages);
        } else if (filterIndex === 1) {
            setFilteredGallery(innerCarImages);
        } else {
            setFilteredGallery(wheels);
        }
        setActiveImage(0);
    }

    return (
        <Fragment>
            <div className={""} style={{ opacity: (isFullScreen === true ? 1 : 0), position: (isFullScreen === true ? "relative" : "fixed"), zIndex: (isFullScreen === true ? 999999 : -1) }}>
                <ImageGallery ref={popRef} items={filteredGallery} onScreenChange={(e) => setIsFullScreen(e)} />
            </div>

            <div className={"vehicle-filter-group mb-24 mx-auto container "}>
                <div className={"flex flex-row justify-center items-center flex-wrap nice-gap-1rem mb-24"}>
                    {isLoading ? (
                        <div className="flex gap-4">
                            <Skeleton width={120} height={40} borderRadius={20} />
                            <Skeleton width={120} height={40} borderRadius={20} />
                            <Skeleton width={120} height={40} borderRadius={20} />
                        </div>
                    ) : (
                        <Fragment>
                            {outerCarImages?.length > 0 && <FilterButton onclick={() => { setActivePart(0); filterImage(0); }} name={trans("car:external-images")} isActive={activePart === 0} />}
                            {innerCarImages?.length > 0 && <FilterButton onclick={() => { setActivePart(1); filterImage(1); }} name={trans("car:internal-images")} isActive={activePart === 1} />}
                            {wheels?.length > 0 && <FilterButton onclick={() => { setActivePart(2); filterImage(2); }} name={trans("info:wheels")} isActive={activePart === 2} />}
                        </Fragment>
                    )}
                </div>
            </div>

            <div className={"gallery container mb-32"} >
                {isLoading ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-100">
                        {[1, 2, 3, 4, 5, 6].map((i) => (
                            <Skeleton key={i} height={250} borderRadius={16} />
                        ))}
                    </div>
                ) : filteredGallery?.length > 0 ? (
                    filteredGallery.map((img, index) => (
                        <div
                            key={index}
                            className={"gallery-item"}
                            onClick={() => {
                                setActiveImage(index);
                                try {
                                    if (popRef.current) {
                                        popRef.current.toggleFullScreen();
                                        popRef.current.slideToIndex(index);
                                    }
                                } catch (error) { console.log(error); }
                            }}
                        >
                            <img
                                key={img?.type + "-" + index}
                                src={config.FilePathURL + img.imagePath}
                                onError={e => e.target.style.display = 'none'}
                                className={"object-full object-cover "}
                                alt={img.name}
                            />
                            <span className="gallery-item-ovrlay">
                                <svg className="image-gallery-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
                                </svg>
                            </span>
                        </div>
                    ))
                ) : (
                    <div className="w-100">
                        <EmptyState message={trans("vehicales:no-gallery-data") || "No gallery images available"} />
                    </div>
                )}
            </div>
        </Fragment>
    );
}